<div class="mobile-nudge-container" (click)="routeToUniqodeCards()" (keyup)="routeToUniqodeCards()" (keydown)="routeToUniqodeCards()">
    <div class="mobile-nudge-content p-3">
        <div class="mobile-nudge-text">
            <i class="fa fa-mobile-alt fa-2x pr-2 mobile-icon pr-3"></i>
            Click to view and share your cards directly from your phone
        </div>
    </div>
</div>
